import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Item, Card, Header, Button } from 'semantic-ui-react';
import Image from '../../atoms/Image';
import { EventButton } from '../../modules/analytics/components';
import { contentExceedsCharLimit, getShortenedText } from '../../modules/foundation/components/ExpandableText/ExpandableText.utils';
import { StylePropType } from '../../services/proptypes';
import './ItemElement.css';
var ItemElement = /*#__PURE__*/function (_React$Component) {
  _inherits(ItemElement, _React$Component);
  var _super = _createSuper(ItemElement);
  function ItemElement(props) {
    var _this;
    _classCallCheck(this, ItemElement);
    _this = _super.call(this, props);
    var _this$props = _this.props,
      content = _this$props.content,
      charLimit = _this$props.charLimit;
    _this.state = {
      currentContent: contentExceedsCharLimit(content, charLimit) ? getShortenedText(content, charLimit) : content,
      buttonText: 'See More'
    };
    _this.expandOrContractLongText = _this.expandOrContractLongText.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(ItemElement, [{
    key: "expandOrContractLongText",
    value: function expandOrContractLongText() {
      var _this$props2 = this.props,
        content = _this$props2.content,
        charLimit = _this$props2.charLimit;
      var buttonText = this.state.buttonText;
      if (buttonText === 'See More') {
        this.setState({
          currentContent: content,
          buttonText: 'See Less'
        });
      }
      if (buttonText === 'See Less') {
        this.setState({
          currentContent: getShortenedText(content, charLimit),
          buttonText: 'See More'
        });
      }
    }
  }, {
    key: "renderEventButton",
    value: function renderEventButton() {
      var fluid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var floated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _this$props3 = this.props,
        event = _this$props3.event,
        buttonSize = _this$props3.buttonSize,
        buttonBasic = _this$props3.buttonBasic,
        buttonColor = _this$props3.buttonColor;
      var buttonText = this.state.buttonText;
      if (event) {
        return /*#__PURE__*/React.createElement(EventButton, {
          className: "itemelement-more-button",
          event: event,
          color: buttonColor,
          fluid: fluid,
          floated: floated,
          primary: true,
          onClick: this.expandOrContractLongText,
          basic: buttonBasic,
          size: buttonSize
        }, buttonText);
      }
      return /*#__PURE__*/React.createElement(Button, {
        className: "itemelement-more-button",
        color: buttonColor,
        fluid: fluid,
        primary: true,
        onClick: this.expandOrContractLongText,
        basic: buttonBasic,
        size: buttonSize
      }, buttonText);
    }
  }, {
    key: "renderCard",
    value: function renderCard() {
      var _this$props4 = this.props,
        className = _this$props4.className,
        style = _this$props4.style,
        imageCircular = _this$props4.imageCircular,
        imageSize = _this$props4.imageSize,
        itemCenterContent = _this$props4.itemCenterContent,
        link = _this$props4.link,
        linkAs = _this$props4.linkAs,
        header = _this$props4.header,
        headerIcon = _this$props4.headerIcon,
        image = _this$props4.image,
        subheader = _this$props4.subheader,
        cardInlinePhoto = _this$props4.cardInlinePhoto,
        charLimit = _this$props4.charLimit,
        content = _this$props4.content;
      var asLink = linkAs === 'header' && link;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/React.createElement(Card, {
        className: className,
        style: style,
        fluid: true
      }, !cardInlinePhoto && image && /*#__PURE__*/React.createElement(Image, {
        className: "itemelement-card-image",
        src: image,
        fluid: true
      }), /*#__PURE__*/React.createElement(Card.Content, null, cardInlinePhoto && image && /*#__PURE__*/React.createElement(Image, {
        className: "itemelement-card-image",
        floated: cardInlinePhoto,
        size: imageSize,
        circular: imageCircular,
        src: image
      }), header && /*#__PURE__*/React.createElement(Card.Header, {
        className: "itemelement-card-header",
        as: asLink ? 'a' : '',
        href: asLink ? link : '',
        textAlign: itemCenterContent ? 'center' : 'left'
      }, header, headerIcon), subheader && /*#__PURE__*/React.createElement(Card.Meta, {
        className: "itemelement-card-subheader",
        textAlign: itemCenterContent ? 'center' : 'left'
      }, subheader), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card.Description, {
        textAlign: itemCenterContent ? 'center' : 'left'
      }, currentContent))), contentExceedsCharLimit(content, charLimit) && /*#__PURE__*/React.createElement(Card.Content, {
        textAlign: itemCenterContent ? 'center' : 'left',
        extra: true
      }, this.renderEventButton(true)));
    }
  }, {
    key: "renderVerticalItem",
    value: function renderVerticalItem() {
      var _this$props5 = this.props,
        className = _this$props5.className,
        style = _this$props5.style,
        content = _this$props5.content,
        imageSize = _this$props5.imageSize,
        imageCircular = _this$props5.imageCircular,
        verticalItemAlign = _this$props5.verticalItemAlign,
        link = _this$props5.link,
        linkAs = _this$props5.linkAs,
        header = _this$props5.header,
        headerIcon = _this$props5.headerIcon,
        image = _this$props5.image,
        subheader = _this$props5.subheader,
        charLimit = _this$props5.charLimit;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        style: style
      }, image ? /*#__PURE__*/React.createElement(Image, {
        className: "itemelement-card-image",
        src: image,
        size: imageSize,
        circular: imageCircular,
        style: {
          margin: verticalItemAlign === 'center' ? '0 auto -1em auto' : '0'
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: "itemelement-card-image"
      }), header && /*#__PURE__*/React.createElement(Header, {
        icon: true,
        textAlign: verticalItemAlign
      }, /*#__PURE__*/React.createElement(Header.Content, {
        // eslint-disable-next-line max-len
        className: "itemelement-vertical-header itemelement-vertical-header-".concat(verticalItemAlign),
        as: linkAs === 'header' ? 'a' : 'h2',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && /*#__PURE__*/React.createElement(Header.Subheader, {
        className: "itemelement-vertical-subheader"
      }, subheader)), /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: verticalItemAlign
        },
        className: "itemelement-vertical-content"
      }, content && currentContent, contentExceedsCharLimit(content, charLimit) && /*#__PURE__*/React.createElement("div", null, this.renderEventButton(false))));
    }
  }, {
    key: "renderHorizontalItem",
    value: function renderHorizontalItem() {
      var _this$props6 = this.props,
        className = _this$props6.className,
        style = _this$props6.style,
        content = _this$props6.content,
        imageSize = _this$props6.imageSize,
        link = _this$props6.link,
        linkAs = _this$props6.linkAs,
        header = _this$props6.header,
        headerIcon = _this$props6.headerIcon,
        image = _this$props6.image,
        subheader = _this$props6.subheader,
        itemCenterContent = _this$props6.itemCenterContent,
        itemButtonFloat = _this$props6.itemButtonFloat,
        charLimit = _this$props6.charLimit;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/React.createElement(Item, {
        className: className,
        style: style
      }, image && /*#__PURE__*/React.createElement(Item.Image, {
        size: imageSize,
        src: image
      }), /*#__PURE__*/React.createElement(Item.Content, {
        verticalAlign: itemCenterContent ? 'middle' : 'top'
      }, header && /*#__PURE__*/React.createElement(Item.Header, {
        className: "itemelement-horizontal-header",
        as: linkAs === 'header' && link ? 'a' : '',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && /*#__PURE__*/React.createElement(Item.Meta, null, subheader), content && /*#__PURE__*/React.createElement(Item.Description, null, currentContent), contentExceedsCharLimit(content, charLimit) && /*#__PURE__*/React.createElement(Item.Extra, null, this.renderEventButton(false, itemButtonFloat))));
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      if (as === 'verticalItem') return this.renderVerticalItem();
      if (as === 'horizontalItem') return this.renderHorizontalItem();
      if (as === 'card') return this.renderCard();
      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);
  return ItemElement;
}(React.Component);
export { ItemElement as default };
ItemElement.defaultProps = {
  className: '',
  style: {},
  as: 'horizontalItem',
  buttonColor: 'blue',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  charLimit: 150,
  content: '',
  headerIcon: null,
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  subheader: '',
  verticalItemAlign: 'center',
  event: {}
};
ItemElement.propOptions = {
  buttonColor: ['primary', 'secondary']
};